import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/23.mp3"
export default function P1() {
    return (
        <MainLayout
        title="Podchodzisz do kobiety"     
        question="" 
            audio={audio}
        answers={{
            ans1: "Dalej",
        }}
        links={{
            link1: PAGES.p38,
        }}
        content={
            <div>
                <ul>
                    <li>Dzień dobry – wita cię serdecznie Helga Horn.</li>
                    <li>Jesteście rybakami? – pytasz.</li>
                    <li>Mąż łowi ryby i dba o starorzecza, stawy, łąki. A ja mam swoje zadania. Dobrze, że woda tu i ówdzie została, to i robota łatwo idzie. Tutaj każde oczko wodne jest jak osobny warsztat</li>
                    <li>uśmiecha się. Pokazuje ci po kolei starorzecza: – Do Babidołu się chodzi prać, na Moczydle moczy len, a na Ciżemku.... Tutaj żyją żaby, więc staw się nazywa Francuz, a tam, na Gąsieńcu… gęsi. Są jeszcze Kapelusz, Lipówka, Płociczne Moczydło, Kukowy… – Helga pokazuje w stronę łąki, na której przed kilkoma godzinami wypasali swoje stada dwaj gęsiarze.</li>
                    <li>Wasze ryby. Zdrowia życzę! – przerywa wam rozmowę Horn.</li>
                </ul>
            </div>
        }
        />
        
            );
}